import React, { useRef, useState } from "react";
import "../Styles/Contact.scss";
import { useTranslation } from "react-i18next";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const Contact = () => {
  const { t } = useTranslation();
  const formRef = useRef(null);
  const [status, setStatus] = useState("idle"); // idle | sending | success | error
  const [errors, setErrors] = useState({});

  const validate = () => {
    const form = formRef.current;
    const newErrors = {};

    if (!form.from_name.value.trim()) {
      newErrors.from_name = t("contact_error_name");
    }

    if (!form.from_email.value.trim()) {
      newErrors.from_email = t("contact_error_email_required");
    } else if (!emailRegex.test(form.from_email.value)) {
      newErrors.from_email = t("contact_error_email_invalid");
    }

    if (!form.message.value.trim()) {
      newErrors.message = t("contact_error_message");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const sendEmail = (e) => {
    e.preventDefault();

    if (!validate()) return;

    if (!window.emailjs) {
      setStatus("error");
      return;
    }

    setStatus("sending");

    window.emailjs
      .sendForm("service_qfdx9wg", "template_xm0y6jm", formRef.current)
      .then(() => {
        setStatus("success");
        setErrors({});
        formRef.current.reset();
      })
      .catch((error) => {
        console.error(error);
        setStatus("error");
      });
  };

  return (
    <section className="contact">
      {/* Header */}
      <div className="contact-header">
        <h1>{t("contact_title")}</h1>
        <p>{t("contact_description")}</p>
      </div>

      {/* Content */}
      <div className="contact-content">
        <div className="contact-info">
          <h2>{t("contact_get_in_touch")}</h2>
          <div className="info-item">
            <span>📍</span>
            <p>Bamberg, Germany</p>
          </div>

          <div className="info-item">
            <span>📞</span>
            <p>+49 1522 1322803</p>
          </div>

          <div className="info-item">
            <span>✉️</span>
            <p>emi.qazimi90@gmail.com</p>
          </div>
        </div>

        <form
          ref={formRef}
          className="contact-form"
          onSubmit={sendEmail}
          noValidate
        >
          <h2>{t("contact_form_title")}</h2>

          <input
            type="text"
            name="from_name"
            placeholder={t("contact_placeholder_name")}
          />
          {errors.from_name && (
            <span className="field-error">{errors.from_name}</span>
          )}

          <input
            type="email"
            name="from_email"
            placeholder={t("contact_placeholder_email")}
          />
          {errors.from_email && (
            <span className="field-error">{errors.from_email}</span>
          )}

          <input
            type="tel"
            name="phone"
            placeholder={t("contact_placeholder_phone")}
          />

          <textarea
            name="message"
            placeholder={t("contact_placeholder_message")}
            rows="5"
          />
          {errors.message && (
            <span className="field-error">{errors.message}</span>
          )}

          <button type="submit" disabled={status === "sending"}>
            {status === "sending"
              ? t("contact_sending")
              : t("contact_send_button")}
          </button>

          {status === "success" && (
            <p className="form-status success">✅ {t("contact_success")}</p>
          )}

          {status === "error" && (
            <p className="form-status error">❌ {t("contact_error")}</p>
          )}
        </form>
      </div>
    </section>
  );
};

export default Contact;
